module.exports = __webpack_public_path__ + "image-ebc817fb8b0a.png";